import { PricingPlans } from "./partials/PricingPlans";
import { useAppSelector } from "../../store/hooks";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useAnalytics } from "../../hooks/useAnalytics";

const Subscriptions = () => {
  const { data: pricingPlans } = useAppSelector((state) => state.pricingPlans);
  const currentPlan = useAppSelector((state) => state.user.user?.planDetails);
  const { trackViewPricing } = useAnalytics();

  useEffect(() => {
    trackViewPricing(pricingPlans);
  }, [trackViewPricing, pricingPlans]);

  return (
    <>
      <PricingPlans
        plans={pricingPlans}
        currentPlanId={currentPlan?.planId}
        redirectUrl="/account/subscriptions/payment-success"
      />
      <Outlet />
    </>
  );
};

export default Subscriptions;
